export const marketplaceWordmarkImages = {
  Amazon: '/images/marketplaces/amazon.svg',
  Shopify: '/images/marketplaces/shopify.svg',
  eBay: '/images/marketplaces/ebay.svg',
  Sears: '/images/marketplaces/sears.svg',
  Facebook: '/images/marketplaces/facebook.svg',
  Bonanza: '/images/marketplaces/bonanza.svg',
  Walmart: '/images/marketplaces/walmart.svg',
  Temu: '/images/marketplaces/temu.png',
  'Target Plus': '/images/marketplaces/target-plus.png',
};
